module.exports = import("https://www.gstatic.com/firebasejs/10.3.0/firebase-app.js");;